import { render, staticRenderFns } from "./FccProrrogaData.vue?vue&type=template&id=a967fa70"
import script from "./FccProrrogaData.vue?vue&type=script&lang=js"
export * from "./FccProrrogaData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports